import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/speed-to-lead/campaigns")({
  staticData: { title: "Campaigns", breadcrumb: "Campaigns" },
  component: CampaignsLayout,
});

function CampaignsLayout() {
  return <Outlet />;
}
